import React from 'react';

/**
 * @typedef {Object} Org
 * @property {string} id
 * @property {string} code
 * @property {string} name
 * @property {'entp'| string} type
 * @property {'entp'| string} imsType
 * @property {'ADMIN' | 'NOT_ADMIN'} role
 * @property {null} maxApps
 * @property {null} apps
 */

/**
 * @typedef {Object} ContainerContextType
 * @property {Org[]} [orgs]
 * @property {boolean} [orgsLoaded]
//  * @property {ReturnType<typeof import('@exchange-frontends/custom-hooks')['useIMS']>} [ims]
 */

/** @type {React.Context<ContainerContextType>} */
export const ContainerContext = React.createContext({});
